import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { MainService } from './core/main.service';
import { AppConfig } from '../environments/environment';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'
import {Title} from "@angular/platform-browser";
import {Subscription, interval, timer} from 'rxjs';
import { ElectronService } from 'ngx-electron';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public debug:boolean = false;

  private datasServer:any;
  public datasName:any;
  public base:string;
  public datas:any;

  private activityDelay:number = 5*60*1000; //ms
  private activitySubscription:Subscription;

  public debugTxt:string;

  public isVP:any;
  public current:string = 'loading';
  public selected:number;

  public cols:number = 16+2;
  public rows:number = 6+2;
  public boxes:Array<any>;

  public speed:number = 1;

  private espaces:Array<any> = [
  {
    name: 'Végétale',
    color: '#fbab18'
  },
  {
    name: 'Animale',
    color: '#ee4991'
  },
  {
    name: 'Humaine',
    color: '#00aab0'
  },
  {
    name: 'Artificielle',
    color: '#ef4023'
  }
];
public espace;

  @ViewChild('video', {static: false}) videoTag : ElementRef;
  videoProgress:number = 0;

  constructor(
    private service: MainService,
    private sanitizer:DomSanitizer,
    private titleService: Title,
    private electron: ElectronService
  ) {
    this.log('constructor');
  }

  ngOnInit(){
    this.log('ngOnInit');

    if (window.hasOwnProperty('process') && window['process'].hasOwnProperty('versions') && window['process']['versions'].hasOwnProperty('electron')) { // electron
      let response: any = this.electron.ipcRenderer.sendSync('ping');
      this.datasName = response.datas;
      this.service.base = response.base;
      this.base = this.service.base;
    } else {
      this.datasName = this.findGetParameter('datas');
      this.base = AppConfig.datasServer;
    }
    this.log("this.datasName", this.datasName);

    this.checkIfVP();
    this.loadDatas();

    window.addEventListener('idal-contact-event', (e) => {
      let info = e['detail'];
      console.log("Input contact name: " + info.name);
      let port = info.values.findIndex(elt => elt);
      if (port == 0){
        this.onButton();
      }
    });
  }

  checkIfVP(){
    // Detect Wave System player in VP330 ou VP320
    this.isVP = navigator.userAgent.search("WSPlayer") != -1;
  }

  loadDatas(){
    this.current = 'loading';
    this.service.loadDatas(this.datasName).subscribe((datas => {
      this.datas = datas;
      this.titleService.setTitle( this.datas.name );
      this.start();
    }));
  }

  start(){
    this.buildBoxes();

    // timer(1000).subscribe(() => {
    //   this.openBox(4, 2, 2, 4)
    //   this.openBox(7, 3, 3, 3)
    // });

    interval(10000/this.speed).subscribe(() => {
      let sel = [];
      while (!sel.length){
        let rnd:number = 0;
        rnd = Math.random();
        let col = 1+Math.floor(rnd*(this.cols-3));
        rnd = Math.random();
        let row = 1+Math.floor(rnd*(this.rows-3));
        sel = this.boxes.filter(box => (box.row == row) && (box.col == col));
      }
      // this.toggle(sel[0]);
    });
    interval(1000/this.speed).subscribe(() => {
      this.bougeUnTruc();
      // this.decRow(5, -1);
    });

    timer(500).subscribe(() => {
      this.current = 'splash';
    });
  }

  bougeUnTruc(){
    if (!this.boxes.filter(elt => elt.scale!=1).length){
      let inc = Math.round(Math.random())*2-1;
      // inc = inc*2;
      if (Math.random()>0.5){
        let row = 1+Math.round(Math.random()*(this.rows-2));
        this.decRow(row, inc);
      } else {
        let col = 1+Math.round(Math.random()*(this.cols-2));
        this.decCol(col, inc);
      }
    }
  }

  buildBoxes(){
    this.boxes = [];
    let cp = 0;
    for (let row:number=0; row<this.rows; row++){
      for (let col:number=0; col<this.cols; col++){
        let quote = this.datas.quotes[cp%this.datas.quotes.length];
        let espace = this.espaces[cp%this.espaces.length];
        this.boxes.push({
          id: cp,
          row: row,
          col: col,
          width: 1,
          height: 1,
          hide: false,
          quote: quote,
          color: espace.color,
          scale: 1,
          origin: '50% 50%'
        });
        cp++;
      }
    }
    // console.log('buildBoxes', this.boxes);

  }

  openHome(){

  }

  findGetParameter(parameterName:string) {
      let result = null,
          tmp = [];
      let items = location.search.substr(1).split("&");
      for (let index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
  }

  onButton(){
    if (this.activitySubscription){
      this.activitySubscription.unsubscribe();
      delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      this.log("activitySubscription");
      this.current = 'splash';
    });
  }

  log(...txts:any){
    if (true || this.isVP){
      this.debugTxt += txts.join(', ');
      this.debugTxt += '<br>';
    } else {
      console.log(...txts);
    }
  }

  decRow(row:number, inc:number){
    // console.log('decRow', row);
    this.boxes.filter((sel) => sel.row == row).map((box) => {
      let col = box.col+inc;
      let modulo = (col+this.cols)%this.cols;
      box.col = modulo;
      box.hide = (col != modulo);
    });
  }
  decCol(col:number, inc:number){
    // console.log('decCol', col);
    this.boxes.filter((sel) => sel.col == col).map((box) => {
      let row = box.row+inc;
      let modulo = (row+this.rows)%this.rows;
      box.row = modulo;
      box.hide = (row != modulo);
    });
  }
  getFrame(box:any, width:number, height:number):any
  {
    let colStart = Math.max(1, Math.round(box.col-width/2));
    let rowStart = Math.max(1, Math.round(box.row-height/2));
    let colEnd = Math.min(this.cols, colStart+width);
    let rowEnd = Math.min(this.rows, rowStart+height);
    colStart = colEnd-width;
    rowStart = rowEnd-height;
    return {width: width, height: height, col: colStart, row: rowStart};
  }
  openCol(col:number, box:any, frame:any){
    let foundBox:boolean = false;
    this.boxes.filter((sel) => sel.col==col).map((elt) => {
      if (elt==box){
        foundBox = true;
      } else {
        let dec = frame.row - box.row;
        if (elt.row < box.row){
          elt.row += dec;
        } else {
          elt.row += frame.height+dec;
          if (foundBox){
            elt.row--;
          }
        }
      }
    });
  }
  openRow(row:number, box:any, frame:any){
    let foundBox:boolean = false;
    this.boxes.filter((sel) => sel.row == row).map((elt) => {
      if (elt==box){
        foundBox = true;
      } else {
        let dec = frame.col - box.col;
        if (elt.col < box.col){
          elt.col += dec;
        } else {
          elt.col += frame.width+dec;
          if (foundBox){
            elt.col--;
          }
        }
      }
    });
  }
  closeRow(row:number){
    let cp = 0;
    this.boxes.filter((sel) => sel.row == row).sort((a, b) => {
      let ret = 0;
      if (a.row < b.row){
        ret = -1;
      } else if (a.row > b.row){
        ret = 1;
      }
      return ret;
    }).map((elt) => {
        elt.col = cp;
        elt.hide = (cp==0) || (cp==this.cols-1);
        cp++;
    });
  }
  openBoxes(box:any, frame:any){
    for (let i:number=0; i<frame.height; i++){
      this.openRow(frame.row+i, box, frame);
      // this.openCol(frame.col+i, box, frame);
    }
  }

  checkMap(msg:string):void{
  
    console.log(msg);
    for (let row:number=0; row<this.rows; row++){
      for (let col:number=0; col<this.cols; col++){
        let sel = this.boxes.filter(box => (box.row == row) && (box.col == col));
        if (sel.length != 1){
          console.log(sel.length, row, col)
        }
      }
    }
  }


  openBox(box:any, frame:any):void
  {
    box.scale = 2;
    box.origin = 100*(box.col-frame.col)/(frame.width-1)+'% '+100*(box.row-frame.row)/(frame.height-1)+'%';
  }
  closeBoxes(){
    for (let i:number=0; i<this.rows; i++){
      this.closeRow(i);
      // this.openCol(frame.col+i, box, frame);
    }
  }
  closeBox(box:any):void
  {
    box.scale = 1;
  }

  open(box):void {
    // console.log('open', box);
    let frame = this.getFrame(box, 2, 2);
    this.openBoxes(box, frame);
    this.openBox(box, frame);
  }
  close():void {
    // console.log('close?');
    this.boxes.filter(elt => elt.scale != 1).forEach(box => {
      // console.log('close', box);
      this.closeBox(box);
      this.closeBoxes();
    });
  }

  toggle(box){
    if (!this.boxes.filter(elt => elt.scale != 1).length){
      this.open(box);
      this.checkMap('open');
    } else {
      this.boxes.filter(elt => elt.scale != 1).forEach(box => {
        this.close();
        this.checkMap('close');
      });
    }
  }
  onClick(box){
    // console.log(box);
    // this.toggle(box);
  }
  onHover(box){
    // console.log(box);
    this.toggle(box);
  }

}
